import type { SearchHit } from "@api/generated/model";
import type { ToOptions } from "@tanstack/react-router";

/** Where a quick-search hit leads, as a typed router location (checked against the target route's search schema).
 *  Kinds whose screen does not exist yet return null and are not offered. */
export function hitTarget(hit: SearchHit): ToOptions | null {
  const r = hit.ref as Record<string, string | number | null>;
  const ev = typeof r.ev === "number" ? r.ev : undefined;
  switch (hit.kind) {
    case "plot":
      return { to: "/trials/data", search: { ev, table: "trms", kis: String(r.kis), th: String(r.th) } };
    case "trial":
      return { to: "/trials/data", search: { ev, table: "trms", kis: String(r.kis) } };
    case "genotype":
      return { to: "/genealogy/genotype", search: { paz: Number(r.paz), sid: Number(r.sid) } };
    case "query":
      return { to: "/trials/queries", search: { q: Number(r.id) } };
    default:
      return null;
  }
}
